module.exports = __webpack_public_path__ + "img/lemon_and_mint_1.3febd333.png";